<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <div class="users">
        <loading-component>
            <template #content>
                <div class="flex flex-col gap-4">
                    <div v-if="false" class="flex flex-row gap-4 items-center text-secondary">
                        <input-component placeholder="Suche" v-model="search"></input-component>

                        <select class="select select-bordered" v-model="page">
                            <option v-for="page in pages" :selected="page === 1" v-bind:key="page" :value="page">
                                {{ page }}
                            </option>
                        </select>
                    </div>

                    <div class="self-end">
                        <button-component
                            fa-icon="fa-regular fa-plus"
                            background-color="bg-green-600"
                            @click="$router.push(`/users/create`)"
                        >
                        </button-component>
                    </div>

                    <div
                        v-if="false"
                        class="sm:px-5 md:px-5 lg:px-10 xl:px-10 2xl:px-[10rem] min-2xl:px-[50rem] p-4 overflow-y-scroll"
                    >
                        <table class="table w-full">
                            <!-- head -->
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Firma</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(user, index) of usersStore.page.users" v-bind:key="index">
                                    <td>
                                        <div class="flex items-center space-x-3">
                                            <div class="avatar">
                                                <div class="mask mask-squircle w-12 h-12">
                                                    <img
                                                        :src="usersStore.getUserAvatar(user.mail)"
                                                        alt="Profilbild"
                                                        class="min-h-12 min-w-12 rounded-full shadow-xl"
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <div v-if="user.name" class="font-bold">Name: {{ user.name }}</div>
                                                <div v-if="user.id" class="text-sm opacity-50">{{ user.id }}</div>
                                            </div>
                                        </div>
                                    </td>

                                    <td>
                                        <div>{{ user.firmation ?? 'Nicht angegben' }}</div>
                                    </td>

                                    <th>
                                        <div class="flex flex-row gap-4 justify-end px-4 pb-4">
                                            <button-component
                                                fa-icon="fa-regular fa-pencil"
                                                @click="$router.push(`/users/${user._id}`)"
                                            />
                                            <delete-component @delete="deleteUser(user._id)" />
                                        </div>
                                    </th>
                                </tr>
                            </tbody>
                            <!-- foot -->
                            <tfoot>
                                <tr>
                                    <th>Benutzer</th>
                                    <th>Firma</th>
                                    <th></th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        <card-component v-for="(user, index) of usersStore.page.users" v-bind:key="index">
                            <template v-slot:body>
                                <div class="flex flex-row gap-4 items-center">
                                    <div>
                                        <img
                                            :src="usersStore.getUserAvatar(user.mail)"
                                            alt="Profilbild"
                                            class="min-h-12 min-w-12 rounded-full shadow-xl"
                                        />
                                    </div>

                                    <div class="flex flex-col">
                                        <h2 class="card-title">{{ user.login }}</h2>

                                        <div class="flex flex-col text-gray-500 text-sm">
                                            <div v-if="user.id">ID: {{ user.id }}</div>
                                            <div>OAuth-ID: {{ user._id }}</div>
                                            <div v-if="user.given_name || user.family_name">
                                                Name:
                                                {{
                                                    [user.given_name, user.family_name].filter((name) => name).join(' ')
                                                }}
                                            </div>
                                            <div v-else-if="user.name">Name: {{ user.name }}</div>
                                            <div>E-Mail: {{ user.mail }}</div>
                                            <div>Firma: {{ user.firmation ?? 'Nicht angegben' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:footer>
                                <button-component
                                    fa-icon="fa-regular fa-pencil"
                                    @click="$router.push(`/users/${user._id}`)"
                                />
                                <delete-component @delete="deleteUser(user._id)" />
                            </template>
                        </card-component>
                    </div>
                </div>
            </template>
        </loading-component>
    </div>
</template>

<script>
import { useUsersStore } from '@/stores/users';
import { mapStores } from 'pinia';
import CardComponent from '@/components/CardComponent';
import LoadingComponent from '@/components/LoadingComponent';
import DeleteComponent from '@/components/DeleteComponent';
import ButtonComponent from '@/components/ButtonComponent';
import InputComponent from '@/components/InputComponent';
import Notifications from '@auth/vue-share/utility/notifications';
import logger from '@auth/vue-share/utility/logger';

export default {
    name: 'UsersView',
    components: { InputComponent, ButtonComponent, DeleteComponent, LoadingComponent, CardComponent },
    data() {
        return {
            page: 1,
            search: '',
            users: []
        };
    },
    computed: {
        ...mapStores(useUsersStore),
        pages: {
            get() {
                return Math.floor(this.usersStore.page.total / this.usersStore.page.size);
            }
        }
    },
    watch: {
        page(value) {
            this.usersStore.fetchPage(value);
        },
        search() {}
    },
    created() {
        this.usersStore.fetchPage(1);
    },
    methods: {
        deleteUser(user) {
            this.usersStore
                .deleteUser(user)
                .then(() => {
                    Notifications.success('Benutzer erfolgreich gelöscht');
                })
                .catch((error) => {
                    Notifications.error('Benutzer konnte nicht gelöscht werden');
                    logger.error('[USER]', error);
                });
        }
    }
};
</script>

<style scoped></style>
